import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import UsuEntPerfilesView from './UsuEntPerfilesView';

const UsuEntPerfilesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.usuEntPerfiles}
      routes={[ROUTES.usuEntidades]}
    >
      <UsuEntPerfilesView />
    </ContainerTemplate>
  );
};

export default UsuEntPerfilesModule;
